<app-page-heading [heading]="heading"
                  [hasBackButton]="true"
                  [backPageName]="backPageName"
                  [customRoute]="customRoute"
                  [tabName]="tabName">
</app-page-heading>

<div class="stepper-container">
  <mat-horizontal-stepper #stepper [linear]="true">
    <mat-step #generalStep [completed]="generalFormGroup.valid">
      <ng-template matStepLabel>Personal</ng-template>
      <form [formGroup]="generalFormGroup">
        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>National ID Number</mat-label>
              <input [formControl]="nationalIdNumberFormControl"
                     (input)="idNumberChange()" maxlength="13" pattern="[0-9]*" type="text" matInput
                     [required]="idNumberExistsFormControl.value"
                     [disabled]="!idNumberExistsFormControl.value">
              <mat-error *ngIf="idErrorMessage">
                {{idErrorMessage}}
              </mat-error>
            </mat-form-field>
            <mat-icon [matTooltip]="getInfoTooltip('National ID Number')" class="info-icon">help_outline</mat-icon>
            <app-element-slide-toggle class="id-exists-slider"
                                      [label]="idNumberExistsFormControl.value ? 'ID No. Available' : 'ID No. Unavailable'"
                                      [formControl]="idNumberExistsFormControl"
                                      (valueChanged)="onIdNumberExistsChange()">
            </app-element-slide-toggle>
          </mat-grid-tile>
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Passport Number</mat-label>
              <input [formControl]="passportNumberFormControl" type="text" matInput
                     [required]="!idNumberExistsFormControl.value">
            </mat-form-field>
            <mat-icon [matTooltip]="getInfoTooltip('Passport Number')" class="info-icon">help_outline</mat-icon>
          </mat-grid-tile>
        </mat-grid-list>

        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Title</mat-label>
              <mat-select [formControl]="titleFormControl" (selectionChange)="onBlurTitle()">
                <mat-option *ngFor="let item of titles" [value]="item.name">
                  {{item.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Title')">help_outline</mat-icon>
          </mat-grid-tile>
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Nationality</mat-label>
              <mat-select [formControl]="nationalityFormControl">
                <mat-option *ngFor="let country of countries" [value]="country.name">
                  {{country.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Nationality')">help_outline</mat-icon>
          </mat-grid-tile>
        </mat-grid-list>

        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>First Name</mat-label>
              <input [formControl]="firstNameFormControl" (blur)="onBlurFirstName()" type="text" required matInput>
            </mat-form-field>
            <mat-icon [matTooltip]="getInfoTooltip('First Name')" class="info-icon">help_outline</mat-icon>
          </mat-grid-tile>
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Language</mat-label>
              <mat-select [formControl]="languageFormControl" required>
                <mat-option *ngFor="let language of languages" [value]="language">
                  {{language.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Language')">help_outline</mat-icon>
          </mat-grid-tile>
        </mat-grid-list>

        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Middle Name</mat-label>
              <input [formControl]="middleNameFormControl" (blur)="onBlurMiddleName()" type="text" matInput>
            </mat-form-field>
            <mat-icon [matTooltip]="getInfoTooltip('Middle Name')" class="info-icon">help_outline</mat-icon>
          </mat-grid-tile>
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Ethnicity</mat-label>
              <mat-select [formControl]="ethnicityFormControl" required>
                <mat-option *ngFor="let ethnicity of ethnicities" [value]="ethnicity">
                  {{ethnicity.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Language')">help_outline</mat-icon>
          </mat-grid-tile>
        </mat-grid-list>

        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
              <mat-form-field>
                <mat-label>Last Name</mat-label>
                <input [formControl]="lastNameFormControl" type="text" (blur)="blurLastNameChange()"
                       (blur)="onBlurLastName()" required matInput>
              </mat-form-field>
              <mat-icon [matTooltip]="getInfoTooltip('Last Name')" class="info-icon">help_outline</mat-icon>
          </mat-grid-tile>
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Association to Principal</mat-label>
              <mat-select [formControl]="associationFormControl" required>
                <mat-option *ngFor="let type of associations" [value]="type.name">
                  {{type.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Association')">help_outline</mat-icon>
          </mat-grid-tile>
        </mat-grid-list>

        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Gender</mat-label>
              <mat-select [formControl]="genderFormControl" required>
                <mat-option *ngFor="let gender of genders" [value]="gender.name">
                  {{gender.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Gender')">help_outline</mat-icon>
          </mat-grid-tile>
          <mat-grid-tile>
            <label>Associated Principal Person</label>
            <mat-radio-group [(ngModel)]="associatedPerson" (change)="onRadioBtnChange()"
                             [ngModelOptions]="{standalone: true}"
                             aria-label="Select yes OR no" class="example-radio-group">
              <mat-radio-button class="radio-button" style="margin-left: 20px;" value="Yes">
                Yes &nbsp;
              </mat-radio-button>
              <mat-radio-button class="radio-button" value="No" checked>
                No
              </mat-radio-button>
            </mat-radio-group>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Associated Person Radio Buttons')">help_outline
            </mat-icon>
          </mat-grid-tile>
        </mat-grid-list>

        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <greydom-date-picker
              label="Date Of Birth"
              [required]="true"
              [formControl]="dateOfBirthFormControl"
              [tooltip]="getInfoTooltip('Date of Birth')">
            </greydom-date-picker>
          </mat-grid-tile>
          <mat-grid-tile *ngIf="associatedPerson === 'Yes'">
            <mat-form-field>
              <mat-label>Principal</mat-label>
              <input matInput type="text" [placeholder]="getInfoTooltip('Associated Person')"
                     [formControl]="associatedPersonFormControl" (input)="onInputChangedSearchAssociatedPerson($event)"
                     [matAutocomplete]="associatedPersonRef" [required]="isRequired">
              <mat-autocomplete #associatedPersonRef="matAutocomplete" [panelWidth]="'40vw'">
                <mat-option (onSelectionChange)="associatedPersonSelected($event.source.value)"
                            *ngFor="let person of associatedPersonData" [value]="person" class="custom-mat-option">
                  {{getPersonName(person)}}
                </mat-option>
              </mat-autocomplete>
              <button (click)="clearAssociatedPerson()" *ngIf="associatedPersonFormControl.value" aria-label="Clear"
                      mat-button mat-icon-button matSuffix>
                <mat-icon style="color: grey;">clear</mat-icon>
              </button>

            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Associated Person')">help_outline</mat-icon>
          </mat-grid-tile>
        </mat-grid-list>
        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Marital Status</mat-label>
              <mat-select [formControl]="maritalStatusFormControl" required>
                <mat-option *ngFor="let status of maritalStatus" [value]="status.name">
                  {{status.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Marital Status')">help_outline</mat-icon>
          </mat-grid-tile>
          <mat-grid-tile>
            <mat-label style="margin-right: 5px;">ID</mat-label>
            <input id="onDigitalCopyUpload" type="file" accept="image/jpeg,application/pdf" [disabled]="true"
                   (change)="handleInputChangeForId($event)"/>
            <mat-icon [matTooltip]="getInfoTooltip('ID')" class="info-icon">help_outline</mat-icon>
          </mat-grid-tile>

        </mat-grid-list>
        <mat-grid-list cols="2" [rowHeight]="listFormRowHeight">
          <mat-grid-tile>
            <greydom-date-picker
              label="Date Of Marriage"
              [formControl]="dateOfMarriageFormControl"
              [tooltip]="getInfoTooltip('Date of Marriage')">
            </greydom-date-picker>
          </mat-grid-tile>
          <mat-grid-tile>
            <mat-label style="margin-right: 5px;">Photo</mat-label>
            <input id="onPhotoUpload" type="file" accept="image/jpeg,application/pdf" [disabled]="true"
                   (change)="handleInputChangeForDigitalCopy($event)"/>
            <mat-icon [matTooltip]="getInfoTooltip('Photo')" class="info-icon">help_outline</mat-icon>
          </mat-grid-tile>
        </mat-grid-list>
        <div class="button-container">
          <button mat-raised-button color="warn" (click)="resetGeneralFormGroup()">Clear</button>
          <button mat-raised-button matStepperNext color="primary">Next</button>
        </div>
      </form>
    </mat-step>
    <mat-step #statusStep [completed]="statusFormGroup.valid">
      <ng-template matStepLabel>Status</ng-template>
      <form [formGroup]="statusFormGroup">
        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile *ngIf="!isEdit">
            <label>Add To Membership</label>
            <mat-radio-group [(ngModel)]="addToMembership" [ngModelOptions]="{standalone: true}"
                             aria-label="Select yes OR no" class="example-radio-group"
                             (change)="onRemunerationChange()">
              <mat-radio-button class="radio-button" style="margin-left: 20px;" value="Yes">
                Yes &nbsp;
              </mat-radio-button>
              <mat-radio-button class="radio-button" value="No" checked>
                No
              </mat-radio-button>
            </mat-radio-group>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Add to Membership Radio Buttons')">help_outline
            </mat-icon>
          </mat-grid-tile>
          <mat-grid-tile *ngIf="isEdit"></mat-grid-tile>
          <mat-grid-tile *ngIf="isEdit">
            <label>Update Cover Status</label>
            <mat-radio-group [(ngModel)]="updateStatus" [ngModelOptions]="{standalone: true}"
                             aria-label="Select yes OR no" class="example-radio-group">
              <mat-radio-button class="radio-button" style="margin-left: 20px;" value="Yes">
                Yes &nbsp;
              </mat-radio-button>
              <mat-radio-button class="radio-button" value="No" checked>
                No
              </mat-radio-button>
            </mat-radio-group>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Update Status Radio Buttons')">help_outline
            </mat-icon>
          </mat-grid-tile>
        </mat-grid-list>
        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <app-content-field *ngIf="isEdit" [label]="'Card Number'"
                               [content]="insuredPerson?.cardNumber"></app-content-field>

            <mat-form-field *ngIf="!isEdit && addToMembership == 'Yes'">
              <mat-label>Policy Number</mat-label>
              <input required matInput type="text"
                     [placeholder]="getInfoTooltip('Policy Number')"
                     [formControl]="policyFormControl"
                     (input)="policyNumberTextChanged$.next($any($event.target).value)"
                     (blur)="onBlurPolicyNumber()"
                     [matAutocomplete]="policyAuto">
              <mat-autocomplete #policyAuto="matAutocomplete" [panelWidth]="'40vw'">
                <mat-option (onSelectionChange)="onPolicySelected($event.source.value)"
                            *ngFor="let policy of filteredPolicies"
                            [value]="getPolicyDisplayString(policy)"
                            class="custom-mat-option">
                  {{getPolicyDisplayString(policy)}}
                </mat-option>
              </mat-autocomplete>
              <button *ngIf="policyFormControl.value" aria-label="Clear"
                      mat-button mat-icon-button matSuffix
                      (click)="clearPolicy()">
                <mat-icon style="color: grey;">clear</mat-icon>
              </button>
            </mat-form-field>
            <mat-icon *ngIf="!isEdit && addToMembership == 'Yes'" class="info-icon" [matTooltip]="getInfoTooltip('Policy')">help_outline</mat-icon>

            <p *ngIf="!isEdit && addToMembership == 'No'" class="column-label">Choose whether to add the person to an existing membership</p>
          </mat-grid-tile>
          <!-- Show if in add mode (but disabled), or if updating the status -->
          <mat-grid-tile *ngIf="!isEdit || updateStatus === 'Yes'">
            <mat-form-field>
              <mat-label>Status</mat-label>
              <mat-select [formControl]="statusFormControl" [disabled]="!isEdit">
                <mat-option *ngFor="let status of coverStatuses" [value]="status">
                  {{status.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-icon [matTooltip]="getInfoTooltip('Status')" class="info-icon">help_outline</mat-icon>
          </mat-grid-tile>
        </mat-grid-list>
        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <mat-form-field *ngIf="!isEdit && addToMembership == 'Yes'">
              <mat-label>Product</mat-label>
              <mat-select [formControl]="productFormControl" required
                          (selectionChange)="onProductSelected($event.source.value)">
                <mat-option *ngFor="let product of products" [value]="product.productId">
                  {{products.length > 1 ? getProductDisplayName(product) : product.name}}
                </mat-option>
              </mat-select>
              <button *ngIf="productFormControl.value" aria-label="Clear"
                      mat-button mat-icon-button matSuffix
                      (click)="clearProduct()">
                <mat-icon style="color: grey;">clear</mat-icon>
              </button>
            </mat-form-field>
            <mat-icon *ngIf="!isEdit && addToMembership == 'Yes'" class="info-icon" [matTooltip]="getInfoTooltip('Product')">help_outline</mat-icon>
          </mat-grid-tile>
          <!-- Show if in add mode (required), or if updating the status -->
          <mat-grid-tile *ngIf="!isEdit || updateStatus === 'Yes'">
            <greydom-date-picker
              label="Cover Start Date"
              [required]="!isEdit"
              [formControl]="statusStartDateFormControl"
              [tooltip]="getInfoTooltip('Status Start Date')"
              [minDate]="minDate">
            </greydom-date-picker>
          </mat-grid-tile>
        </mat-grid-list>
        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Alternative Card Number</mat-label>
              <input [formControl]="alternativeCardNumberFormControl" type="text" matInput>
            </mat-form-field>
            <mat-icon [matTooltip]="getInfoTooltip('Alternative Card Number')" class="info-icon">help_outline</mat-icon>
          </mat-grid-tile>
          <mat-grid-tile *ngIf="updateStatus === 'Yes'">
            <div class="align-center">
              <div *ngIf="!statusRequiredFieldsSelected" class="font-red">{{statusErrorMessage}}
              </div>
              <br>
              <button mat-raised-button color="primary" (click)="selectedStatus()">Update Cover</button>
            </div>
          </mat-grid-tile>
        </mat-grid-list>
        <mat-divider style="margin-bottom: 16px;margin-top: 16px;"
                     *ngIf="selectedCoverStatuses.length > 0"></mat-divider>
          <div style="width: 46%; float: left;">
            <div style="width: 25vw;padding-left: 10.5vw;">

            </div>
          </div>
          <div style="width: 48%; float: right;padding-left: 25px;">
            <mat-error class="left-content claim-column-label"
                       *ngIf="statusFormGroup.errors && statusFormGroup.errors.minimumCoveredStatus">{{minStatusError}}
            </mat-error>
            <div style="width: 25vw;padding-left: 12.5vw;">
              <div *ngIf="selectedCoverStatuses && selectedCoverStatuses.length > 0" class="left-content">
                <label class="column-label claim-column-label">Cover History</label>
              </div>
              <div class="left-content reporting-list" *ngFor="let coverStatuses of selectedCoverStatuses">
                <p>
                  {{getCoveredStatusDisplayString(coverStatuses)}}
                </p>
              </div>
            </div>
          </div>
        <div class="button-container">
          <button #addressBackButton mat-raised-button matStepperPrevious color="primary">Back</button>
          <button mat-raised-button color="warn" (click)="resetStatusFormGroup()">Clear</button>
          <button mat-raised-button matStepperNext color="primary">Next</button>
        </div>
      </form>
    </mat-step>
    <mat-step #addressStep [completed]="addressFormComponent?.selectedAddresses?.length>0">
      <ng-template matStepLabel>Addresses</ng-template>
      <greydom-address-form #addressFormComponent
                            [data]="insuredPerson">
      </greydom-address-form>
    </mat-step>
    <mat-step #contactsStep [completed]="contactFormComponent?.selectedContacts?.length>0">
      <ng-template matStepLabel>Contacts</ng-template>
      <greydom-contact-form #contactFormComponent
                            [data]="insuredPerson"
                            [formInputs]="contactFormInputs">
      </greydom-contact-form>
    </mat-step>
    <mat-step #statutoryStep [completed]="medicalHistoryFormGroup.valid">
      <ng-template matStepLabel>Medical History</ng-template>
      <form [formGroup]="medicalHistoryFormGroup">

        <!-- Row 0 -->
        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <p class="label">Pre-Existing Conditions</p>
          </mat-grid-tile>
          <mat-grid-tile>
            <label>Previous Medical Aid</label>
            <mat-radio-group [(ngModel)]="previousMedicalAid" [ngModelOptions]="{standalone: true}"
                             aria-label="Select yes OR no" class="example-radio-group"
                             (change)="onRemunerationChange()">
              <mat-radio-button class="radio-button" style="margin-left: 20px;" value="Yes">
                Yes &nbsp;
              </mat-radio-button>
              <mat-radio-button class="radio-button" value="No" checked>
                No
              </mat-radio-button>
            </mat-radio-group>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Previous Medical Aid Radio Buttons')">help_outline
            </mat-icon>
          </mat-grid-tile>
        </mat-grid-list>

        <!-- Row 1 -->
        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Condition</mat-label>
              <mat-select [formControl]="conditionFormControl">
                <mat-option *ngFor="let diagnosisGroup of diagnosisGroups" [value]="diagnosisGroup">
                  {{diagnosisGroup.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Condition')">help_outline</mat-icon>
          </mat-grid-tile>
          <mat-grid-tile *ngIf="previousMedicalAid == 'Yes'">
            <mat-form-field>
              <mat-label>Scheme</mat-label>
              <mat-select [formControl]="schemeFormControl" required>
                <mat-option *ngFor="let scheme of schemes" [value]="scheme">
                  {{scheme.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Scheme')">help_outline</mat-icon>
          </mat-grid-tile>
        </mat-grid-list>

        <!-- Row 2 -->
        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <greydom-date-picker
              label="First Treatment Date"
              [formControl]="conditionStartDateFormControl"
              [tooltip]="getInfoTooltip('Condition History Start Date')"
              [maxDate]="conditionEndDateFormControl.value">
            </greydom-date-picker>
          </mat-grid-tile>
          <mat-grid-tile *ngIf="previousMedicalAid == 'Yes'">
            <mat-form-field>
              <mat-label>Association</mat-label>
              <mat-select [formControl]="coverageAssociationFormControl">
                <mat-option *ngFor="let association of associations" [value]="association">
                  {{association.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Association')">help_outline</mat-icon>
          </mat-grid-tile>
        </mat-grid-list>

        <!-- Row 3 -->
        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <greydom-date-picker
              label="Last Treatment Date"
              [formControl]="conditionEndDateFormControl"
              [tooltip]="getInfoTooltip('Condition History End Date')"
              [minDate]="conditionStartDateFormControl.value">
            </greydom-date-picker>
          </mat-grid-tile>
          <mat-grid-tile *ngIf="previousMedicalAid == 'Yes'">
            <mat-form-field>
              <mat-label>Membership Number</mat-label>
              <input [formControl]="coverageMembershipNumberFormControl" type="text" matInput>
            </mat-form-field>
            <mat-icon [matTooltip]="getInfoTooltip('Coverage Membership Number')" class="info-icon">help_outline</mat-icon>
          </mat-grid-tile>
        </mat-grid-list>

        <!-- Row 4 -->
        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>

          </mat-grid-tile>
          <mat-grid-tile *ngIf="previousMedicalAid == 'Yes'">
            <greydom-date-picker
              label="Start Date"
              [required]="true"
              [formControl]="coverageStartDateFormControl"
              [tooltip]="getInfoTooltip('Coverage History Start Date')"
              [maxDate]="coverageEndDateFormControl.value">
            </greydom-date-picker>
          </mat-grid-tile>
        </mat-grid-list>

        <!-- Row 5 -->
        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <button mat-raised-button color="primary" (click)="addCondition()">Add Condition</button>
          </mat-grid-tile>
          <mat-grid-tile *ngIf="previousMedicalAid == 'Yes'">
            <greydom-date-picker
              label="End Date"
              [required]="true"
              [formControl]="coverageEndDateFormControl"
              [tooltip]="getInfoTooltip('Coverage History End Date')"
              [minDate]="coverageStartDateFormControl.value">
            </greydom-date-picker>
          </mat-grid-tile>
        </mat-grid-list>

        <mat-divider style="margin-bottom: 16px;margin-top: 16px;" *ngIf="selectedConditionExclusions && selectedConditionExclusions?.length > 0"></mat-divider>

        <mat-error class="left-content claim-column-label" *ngIf="preExistingConditionError">
          The condition must be selected, and a start date must be provided.
        </mat-error>

        <div *ngIf="selectedConditionExclusions && selectedConditionExclusions.length > 0" class="left-content">
          <label class="column-label claim-column-label">Selected Pre-Existing Conditions</label>
        </div>
        <div class="left-content reporting-list" *ngFor="let condition of selectedConditionExclusions">
          <mat-icon class="table-icon" matTooltip="REMOVE Condition" (click)="removeCondition(condition)">delete</mat-icon>
          <p>
            {{getConditionDisplayString(condition)}}
          </p>
        </div>

        <div class="button-container">
          <button #medicalHistoryBackButton mat-raised-button matStepperPrevious color="primary">Back</button>
          <button mat-raised-button color="warn" (click)="resetMedicalHistoryFormGroup()">Clear</button>
          <button mat-raised-button matStepperNext color="primary">Next</button>
        </div>
      </form>
    </mat-step>
    <mat-step #financialStep [completed]="financialFormGroup.valid">
      <ng-template matStepLabel>Financial</ng-template>
      <form [formGroup]="financialFormGroup">
        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <label>Remuneration History</label>
            <mat-radio-group [(ngModel)]="remunerationHistory" [ngModelOptions]="{standalone: true}"
                             aria-label="Select yes OR no" class="example-radio-group"
                             (change)="onRemunerationChange()">
              <mat-radio-button class="radio-button" style="margin-left: 20px;" value="Yes">
                Yes &nbsp;
              </mat-radio-button>
              <mat-radio-button class="radio-button" value="No" checked>
                No
              </mat-radio-button>
            </mat-radio-group>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Remuneration Radio Buttons')">help_outline
            </mat-icon>
          </mat-grid-tile>
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Tax Number</mat-label>
              <input [formControl]="taxNumberFormControl" type="text" matInput>
            </mat-form-field>
            <mat-icon [matTooltip]="getInfoTooltip('Tax Number')" class="info-icon">help_outline</mat-icon>
          </mat-grid-tile>
        </mat-grid-list>

        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
          </mat-grid-tile>
          <mat-grid-tile>
            <button mat-raised-button color="accent" (click)="openBankAccountDialog()">
              <mat-icon>account_balance</mat-icon>
              {{bankAccountButtonLabel()}}
            </button>
          </mat-grid-tile>
        </mat-grid-list>

        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile *ngIf="remunerationHistory == 'Yes'">
            <mat-form-field>
              <mat-label>Remuneration Amount</mat-label>
              <input [formControl]="remunerationAmountFormControl" type="number" matInput required>
            </mat-form-field>
            <mat-icon [matTooltip]="getInfoTooltip('Remuneration Amount')" class="info-icon">help_outline</mat-icon>
          </mat-grid-tile>
          <mat-grid-tile>

          </mat-grid-tile>
        </mat-grid-list>

        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile *ngIf="remunerationHistory == 'Yes'">
            <mat-form-field>
              <mat-label>Remuneration Period</mat-label>
              <mat-select [formControl]="remunerationPeriodFormControl" required>
                <mat-option *ngFor="let period of periods" [value]="period">
                  {{period.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Remuneration Period')">help_outline</mat-icon>
          </mat-grid-tile>
          <mat-grid-tile>
          </mat-grid-tile>
        </mat-grid-list>

        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile *ngIf="remunerationHistory == 'Yes'">
            <greydom-date-picker
              label="Start Date"
              [required]="true"
              [formControl]="remunerationStartDateFormControl"
              [tooltip]="getInfoTooltip('Remuneration History Start Date')"
              [maxDate]="remunerationEndDateFormControl.value">
            </greydom-date-picker>
          </mat-grid-tile>
          <mat-grid-tile>
          </mat-grid-tile>
        </mat-grid-list>

        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile *ngIf="remunerationHistory == 'Yes'">
            <greydom-date-picker
              label="End Date"
              [formControl]="remunerationEndDateFormControl"
              [tooltip]="getInfoTooltip('Remuneration History End Date')"
              [minDate]="remunerationStartDateFormControl.value">
            </greydom-date-picker>
          </mat-grid-tile>
          <mat-grid-tile>
          </mat-grid-tile>
        </mat-grid-list>

        <div class="button-container">
          <button #activityBackButton mat-raised-button matStepperPrevious color="primary">Back</button>
          <button #activityClearButton mat-raised-button color="warn" (click)="resetStatutoryFormGroup()">Clear</button>
          <button #finishButton mat-raised-button matStepperNext color="primary" [disabled]="disableFinishButton()"
                  (click)="submitInsuredPerson()">Finish
            <mat-icon *ngIf="createdBySystem()" class="info-icon" [matTooltip]="disableTooltip()">help_outline
            </mat-icon>
          </button>
        </div>
      </form>
    </mat-step>
  </mat-horizontal-stepper>

</div>
